<template>
  <span class="mm-notify">
    <el-button type="primary" :disabled="loading || isOpen" @click="showNote()">{{ loading ? 'loading' : btnText }}</el-button>
    <el-button type="primary" v-if="isOpen" @click="editNote">Edit Note</el-button>
    <el-dialog :visible.sync="editDialogVisible" :close-on-click-modal="false">
			<span slot="title">Edit Note</span>
      <div class="editor-wrap">
        <quillEditor
          style="height:300px"
          v-model="editorContent"
          :options="editorOptions"
        >
        </quillEditor>
      </div>
      <div style="text-align: right;">
			<el-button type="primary" @click='saveNote()'>Save</el-button>
      </div>
    </el-dialog>
  </span>
</template>

<script>
import { quillEditor } from 'vue-quill-editor';
export default {
  components: {
    quillEditor,
  },
  data() {
    return {
      loading: false,
      isOpen: false,
      notifyRef: null,
      editDialogVisible: false,
      editorContent: '',
      editorOptions: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
            ['blockquote', 'code-block'],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
            [{ 'direction': 'rtl' }],                         // text direction

            [{ 'size': [false, 'large', 'huge'] }],  // custom dropdown
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

            [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
            [{ 'align': [] }],
          ]
        }
      }
    };
  },
  props: {
    btnText: {
      default: 'Note',
    },
    notePath: {
      default: '',
    },
  },
  methods: {
    async showNote() {
      this.loading = true;
      this.result = await this.$post('/note/detail',{ path: this.notePath });
      if (this.result && this.result.content) {
        this.editorContent = this.result.content;
      }
      this.loading = false;
      this.isOpen = true;
      this.notifyRef = this.$notify({
        title: 'Note',
        dangerouslyUseHTMLString: true,
        customClass: 'custom-note-notify',
        message: `<div class="ql-editor" style="width:360px;max-height:700px;overflow-wrap: break-word;font-size:17px;">${this.result.content}</div>`,
        duration: 0,
        onClose: () => {
          this.isOpen = false;
        }
      });
    },
    editNote() {
      this.notifyRef.close();
      this.editDialogVisible = true;
    },
    async saveNote() {
      this.result = await this.$post('/note/update',{ path: this.notePath, content: this.editorContent });
      this.editorContent = '';
      this.editDialogVisible = false;
    }
  }
}
</script>

<style>
.el-button +.mm-notify {
  padding-left: 10px;
}
.custom-note-notify {
    width: 400px;
}
</style>
<style scoped>
.editor-wrap {
  height: 400px;
}
</style>